import type { HandlingUnit } from "~/shared/types/quote-details-types";

const isEmptyText = (value?: string | null): boolean =>
	value == null || value.trim() === "";

const isEmptyOption = (
	option?: { name?: string; code?: string } | null,
): boolean => isEmptyText(option?.code) && isEmptyText(option?.name);

/**
 * True when the user hasn't entered anything into a handling unit, so it can
 * be replaced by saved commodities instead of being saved as an empty row.
 */
export const isBlankHandlingUnit = (handlingUnit: HandlingUnit): boolean =>
	isEmptyText(handlingUnit.description) &&
	handlingUnit.quantity == null &&
	isEmptyOption(handlingUnit.unit) &&
	handlingUnit.weight == null &&
	handlingUnit.length == null &&
	handlingUnit.width == null &&
	handlingUnit.height == null &&
	isEmptyOption(handlingUnit.class) &&
	isEmptyText(handlingUnit.nmfc) &&
	handlingUnit.pieceCount == null &&
	!handlingUnit.isStackable &&
	!handlingUnit.isHazmat;
